import {createSlice} from '@reduxjs/toolkit'

const initialApp = () => {
    return {}
}

export const appSlice = createSlice({
    name: 'app',
    initialState: {
        data: initialApp()
    },
    reducers: {
        setApp: (state, action) => {
            state['data'] = {...state['data'], ...action.payload}
        }
    }
})

export const {setApp} = appSlice.actions

export default appSlice.reducer